import { createAction } from '@reduxjs/toolkit';
import { DRAWER__SET_STATUS } from 'store/constants';

export const setDrawerStatusAction = createAction<boolean>(DRAWER__SET_STATUS);
